export const SET_LOADING_TENANTS = 'TENANTS_SET_LOADING_TENANTS';
export const LOAD_TENANTS = 'TENANTS_LOAD_TENANTS';
export const SET_CREATING_TENANT = 'TENANTS_SET_CREATING_TENANT';
export const CREATE_TENANT = 'TENANTS_CREATE_TENANT';
export const SET_UPDATING_TENANT = 'TENANTS_SET_UPDATING_TENANT';
export const UPDATE_TENANT = 'TENANTS_UPDATE_TENANT';
export const SET_DELETING_TENANT = 'TENANTS_SET_DELETING_TENANT';
export const DELETE_TENANT = 'TENANTS_DELETE_TENANT';
export const RESET = 'TENANTS_RESET';